import { render } from "./UserProfil.vue?vue&type=template&id=4baae7b6&scoped=true"
import script from "./UserProfil.vue?vue&type=script&lang=js"
export * from "./UserProfil.vue?vue&type=script&lang=js"

import "./UserProfil.vue?vue&type=style&index=0&id=4baae7b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baae7b6"]])

export default __exports__